export default __webpack_public_path__ + "static/media/navbar-password-orange.edb56748.svg";